<template>
  <div>
    <subscribe-back-instock-dialog-component 
      v-if="subscriptionDialogHtml" 
      :html="subscriptionDialogHtml"
        v-on:closedialog="onCloseDialog"></subscribe-back-instock-dialog-component>
    <div v-if="notFound">
      <h1>Oeps</h1>
      <p>
        De pagina werd niet gevonden. Ga terug naar onze
        <a href="/">homepagina</a>.
      </p>
      <p></p>
    </div>
    <div v-if="error">
      <h1>Oeps</h1>
      <p>Er ging iets mis, probeer het later even opnieuw.</p>
      <p></p>
    </div>
    <div v-if="!notFound && !error">
      <product-page-filterdialog-component
        v-if="searchFacet"
        :searchfacet="searchFacet"
        :selectedfacets="selectedFacets"
        :selectedinput="selectedInput(searchFacet)"
        :page="category"
        v-on:closedialog="onCloseDialog"
        v-on:facetsselected="onFacetsSelected"
      ></product-page-filterdialog-component>
      <div class="page category-page" style="display: flex; width: 100%;">
        <div class="category-filters-dark-overlay"></div>
        <div class="category-filters">
          <h2 class="hide-desktop">Filteren</h2>
          <div class="filter" v-if="selectedDateInterval">
            <span class="filter__title">verschijningsdatum</span>
            <ul>
              <li class="filter__item" v-for="interval in dateIntervals" :key="interval.id">
                <span class="radio-button" 
                @click="onDateIntervalSelected(interval.id)">
                  <span class="radio-button__radio" v-bind:class="{ 'radio-button__radio--active': interval.id === selectedDateInterval }"></span>
                  <span class="radio-button__radioinnerdot" v-if="interval.id === selectedDateInterval"></span>
                  <span class="radio-button__description">{{interval.label}} ({{interval.count}})</span>
                </span>
              </li>
            </ul>
          </div>
          <div v-else class="filter">
            <span class="filter__title">categorie</span>
            <ul>
              <li class="filter__item" v-for="item in categories" :key="item.name">
                <a
                  v-bind:class="{ active: item.id === category }"
                  v-on:click="onCategorySelected(item.id)"
                >{{item.label}} ({{item.count}})</a>
              </li>
            </ul>
          </div>
          <product-page-filter-component
            v-for="facet in availableFilters"
            :key="facet.id"
            :categoryid="facet.label"
            :facetlabel="facet.label"
            :facetitems="facet.filters"
            :selectedinput="selectedInput(facet.label)"
            v-on:facetsselected="onFacetsSelected"
            v-on:searchfacet="onSearchFacet"
          ></product-page-filter-component>
        </div>
        <div class="view-filter-results">
          <button
            class="btn-primary-alternative hide-desktop"
            @click="closeMobileFilters()"
          >Bekijk {{ totalCount }} resultaten</button>
        </div>
        <div class="striep-product-row">
          <div class="product-page-header" style="width: 100%;">
            <h1 class="product-c">{{ pageTitle }}</h1>
            <div v-html="categoryDescription" v-if="categoryDescription" style="width: 100%; margin: 8px 0;"></div>
            <div class="product-page-header-right">
              <span class="hide-mobile">{{ totalCount }} resultaten</span>
              <span class="hide-mobile">|</span>
              <label for="sort">Sorteer op:</label>
              <select @change="onChangeSort" v-model="selectedSort" id="sort" name="sort">
                <option v-for="sort in sorts" :key="sort.name" :value="sort.name">{{ sort.label }}</option>
              </select>
            </div>
            <div class="selected-filters-container" v-if="selectedFilters.reduce((acc, val) => acc.concat(val.values), []).length > 0">
              <span>filters: </span>
                <ul class="selected-filters">
                  <template v-for="selectedFacet in selectedFilters">
                    <li v-for="facetValue in selectedFacet.values" title="Verwijder filter" class="selected-filter__item" @click="onClickSelectedFilter($event, selectedFacet.name, facetValue)" :key="facetValue">
                        <span class="selected-filter__name">{{selectedFacet.name}} | {{ getLabel(selectedFacet.name, facetValue) }}</span>
                        <img class="selected-filter__remove-icon" src="/Themes/Striep2/Content/svg/trash-2.svg" />
                    </li>
                  </template>
                    
                    <li v-if="selectedFilters.reduce((acc, val) => acc.concat(val.values), []).length > 1" title="Verwijder alle filters" class="selected-filter__item selected-filter__item--link" @click="onClickRemoveAllFilters">
                        <img class="selected-filter__remove-icon" src="/Themes/Striep2/Content/svg/trash-2.svg" />
                        <span class="btn-remove-all-filters__label">Verwijder alle filters</span>
                    </li>
                </ul>
            </div>
            <div class="product-page-header-mobile-filter hide-desktop">
              <button
                class="btn-primary-alternative"
                @click="openMobileFilters()"
              >Resultaten filteren</button>
            </div>
          </div>
          <div v-if="totalCount == 0">
            <p>We hebben geen producten gevonden voor de geselecteerde filters. Probeer enkele geselecteerde filters te verwijderen.</p>
          </div>
          <div
            v-for="product in products"
            v-bind:class="category + ' striep-product-box' + ' ' + (product.isPromoPakket ? 'promopakket' : '')"
            :key="product.id"
          >
            <div class="square-box">
              <a class="square-content" :href="product.url">
                <template v-if="product.isPromoPakket">
                  <img
                    v-for="imageUrl in product.imageUrls"
                    v-bind:class="'striep-product-box__image' + product.imageUrls.length"
                    alt
                    v-bind:src="imageUrl"
                    title
                    :key="imageUrl"
                  />
                </template>
                <img v-else alt v-bind:src="product.imageUrls[0]" title />
              </a>
            </div>

            <div class="striep-product-box-meta-data">
              <span class="striep-product-box-meta-data__title">
                <a v-bind:href="product.url">{{ product.title }}</a>
              </span>
              <div class="striep-product-box-meta-data__line">
                <span v-if="product.cover" class="striep-product-box-meta-data__cover">{{ product.cover }}</span>
                <span v-if="product.oldPrice" class="old-price">&euro; {{product.oldPrice}}</span>
                <span class="current-price">&euro;&nbsp;{{ product.price }}</span>
              </div>
               <div class="striep-product-box-meta-data__line add-to-cart-button-container">
                 <button v-if="product.inStock" @click="addToCart(product.id)" class="button-1 add-to-cart-button add-to-cart-button__overview"><img class="button-icon" src="/Themes/Striep2/Content/svg/shopping-bag-white.svg"></button>
                 <button v-else @click="backInStock(product.id)" class="button-2 subscribe-button subscribe-button__overview"><img class="button-icon" src="/Themes/Striep2/Content/svg/mail-darkgray.svg"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="totalCount > 0" class="category-pagination">
        <product-page-pagination-component
          :totalitemcount="totalCount"
          :visiblepagecount="9"
          :currentpage="page"
          :pagesize="pageSize"
          v-on:changepage="onPageChanged"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { hasClass, addClass, removeClass, displayBarNotification } from "@/helpers/functions";
export default {
  data: function () {
    return {
      availableSorts: [],
      facets: null,
      products: [],
      selectedFacets: [],
      sorts: [],
      page: 1,
      pageSize: 24,
      totalCount: null,
      selectedSort: null,
      searchFacet: null,
      category: null,
      categories: [],
      mobileCategoryElement: null,
      notFound: false,
      error: false,
      subscriptionDialogHtml: null,
      categoryDescription: null,
      categoryName: null,
      selectedDateInterval: null,
      dateIntervals: null,
      isSeriesDetail: false
    };
  },
  computed: {
    availableFilters: function () {
      if(this.isSeriesDetail && this.facets) {
        return this.facets.filter(f => f.name != 'series')
      }else {
        return this.facets;
      }
    },
    selectedFilters: function() {
      if(this.isSeriesDetail) {
        return this.selectedFacets.filter(f => f.name != 'stripreeks')
      }else {
        return this.selectedFacets;
      }
    },
    pageTitle: function() {
      if(this.isSeriesDetail && this.facets) {
        var selectedSeriesId = this.selectedFacets.find(f => f.name == 'stripreeks').values[0];
        let lowerCaseText = this.facets.find(f => f.name == 'series').filters
          .find(f => f.id == selectedSeriesId).label + ' ' + this.categoryName.toLowerCase();
        let titleCaseText = lowerCaseText[0].toUpperCase() + lowerCaseText.substring(1, lowerCaseText.length);
        return titleCaseText;
      }else {
        return this.categoryName;
      }
    }
  },
  mounted() {
    window.addEventListener("popstate", function() {
      location.reload();
    }, false);

    this.page = 1;
    this.pageSize = 24;
    let parsedUrl = this.parseUrl();
    let ajaxUrl = this.buildAjaxUrl(
      parsedUrl.category,
      parsedUrl.facetCategories,
      parsedUrl.dateInterval,
      parsedUrl.page,
      parsedUrl.sort
    );
    this.fetchData(ajaxUrl);
  },
  created() {
    this.selectedFacets = [
      { name: "series", label: "reeks", sort: 0, values: [] },
      { name: "publisher", label: "uitgever", sort: 1, values: [] },
      { name: "artists", label: "auteur", sort: 2, values: [] },
      { name: "cover", label: "kaft", sort: 3, values: [] },
    ];
  },
  methods: {
    getLabel: function(facetName, value) {
      let foundFacet = this.facets.find(x => x.label == facetName);
      let label = foundFacet.filters.find(x => x.id == value).label;
      return label;
    },
    onClickSelectedFilter: function ($event, facetName, value) {
      let result = this.selectedFacets.find(x => x.name == facetName).values.filter(x => x !== value);
      this.selectedFacets.find(x => x.name == facetName).values = result;
      this.fetchData();
      this.updateUrl();
    },
    onClickRemoveAllFilters: function() {
      this.selectedFacets.forEach(f => f.values = []);
      this.updateUrl();
    },
    selectedInput: function (facetname) {
      return (
        this.selectedFacets.filter((f) => f.name === facetname)[0]?.values ?? []
      );
    },
    fetchData(url) {
      if (!url) {
        url = this.buildAjaxUrl(
          this.category,
          this.selectedFacets,
          this.selectedDateInterval,
          this.page,
          this.selectedSort
        );
      }

      fetch(url)
        .then((result) => {
          if (!result.ok) {
            if (result.status == 404) {
                this.notFound = true;
                this.error = false;
            } 
            if (result.status == 500) {
                this.error = true;
                this.notFound = false;
            }
            throw Error(result.status);
          }
          return result.json();
        })
        .then((json) => {
          this.notFound = false;
          this.error = false;
          this.facets = json.facetResult;
          this.products = json.products;
          this.sorts = json.availableSorts;
          this.totalCount = json.totalCount;
          this.pageSize = json.pageSize;
          this.selectedFacets = json.selectedFacets;
          this.category = json.selectedCategory;
          this.categoryName = json.selectedCategoryName;
          this.categoryDescription = json.selectedCategoryDescription;
          this.selectedSort = json.selectedSort;
          this.categories = json.categories;
          this.page = json.page;
          this.selectedDateInterval = json.selectedDateInterval;
          this.dateIntervals = json.dateIntervals;
          // let assembled`${this.pageTitle[0].toUpper()}`
          // alert(`${this.pageTitle[0].toUpperCase()}`);
          // alert(`${this.pageTitle[0].toUpper()}${this.pageTitle.substring(1, this.pageTitle.length)} kopen? | De Striep stripspeciaalzaak`);
          // let metadescription = json.metadescription ?? "test";
          // document.getElementsByTagName('meta')["description"].content = json.metadescription;
          document.title = json.metatitle || `${this.pageTitle} kopen? | De Striep`;
        })
        .catch(function () {
        });
    },
    onFacetsSelected: function (values, categoryId) {
      if (!categoryId) {
        categoryId = this.searchFacet;
      }

      this.selectedFacets.find((f) => f.name == categoryId).values = values;

      this.onCloseDialog();
      this.page = 1;
      this.fetchData();
      this.updateUrl();
    },
    openMobileFilters: function () {
      let element = document.querySelector(".category-filters");
      if (!hasClass(element, "visible")) {
        addClass(element, "visible");
        document.querySelector(".category-filters");
        let darkOverlay = document.querySelector(
          ".category-filters-dark-overlay"
        );
        addClass(darkOverlay, "visible");
        let filterResultsButton = document.querySelector(
          ".view-filter-results"
        );
        addClass(filterResultsButton, "visible");

        addClass(document.querySelector("body"), "noscroll");
      }
    },
    closeMobileFilters: function () {
      let element = document.querySelector(".category-filters");
      if (hasClass(element, "visible")) {
        removeClass(element, "visible");
        document.querySelector(".category-filters");
        let darkOverlay = document.querySelector(
          ".category-filters-dark-overlay"
        );
        removeClass(darkOverlay, "visible");
        let filterResultsButton = document.querySelector(
          ".view-filter-results"
        );
        removeClass(filterResultsButton, "visible");

        removeClass(document.querySelector("body"), "noscroll");
      }
    },
    onDateIntervalSelected: function (value) {
      this.selectedDateInterval = value;
      this.page = 1;
      this.fetchData();
      this.updateUrl();
    },
    onCategorySelected: function (value) {
      this.category = value;
      this.page = 1;
      this.selectedSort = null;
      let menuItem = document.querySelector(`.category-navigation a[href*="${value}"]`);
      let activeMenuItem = document.querySelector(`.category-navigation a.active`);
      addClass(menuItem, 'active');
      removeClass(activeMenuItem, 'active');
      this.fetchData();
      this.updateUrl();
    },
    onFacetSelected: function (value) {
      this.selectedFacets.push(value);
      this.page = 1;
      this.fetchData();
    },
    onSearchFacet: function (value) {
      this.searchFacet = value;
    },
    onCloseDialog: function () {
      this.searchFacet = null;
      this.subscriptionDialogHtml = null;
    },
    onChangeSort: function () {
      this.fetchData();
      this.updateUrl();
    },
    onPageChanged: function (page) {
      this.page = page;
      this.fetchData();
      this.updateUrl();
      let element = document.querySelector('.master-wrapper-content');
      element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    },
    addToCart: function(productId) {
      fetch(`/addproducttocart/details/${productId}/1`,
      {
        method: 'post'
      }).then(function(response) {
        return response.json();
      }).then(function(data) {
        displayBarNotification(data.message, data.success);
        if(data.success) {
          let qtyElem = document.querySelector('#cart-qty');
          let qty = qtyElem.innerText;
          qtyElem.innerText = ++qty;
        }
      });
    },
    backInStock: async function(productId) {
      document.querySelector('.master-wrapper-content').style.zIndex = "1"
      var response = await fetch(`/backinstocksubscribe/${productId}`,
      {
        method: 'get'
      });
      var text = await response.text();
      this.subscriptionDialogHtml = text;
    },
    getUrl: function() {
      let categoriesWithFacets = this.selectedFacets
        .filter((c) => c.values.length > 0)
        .sort((c) => c.sort);

      let urlPath = `/${this.category}`;
      if(this.isSeriesDetail) {
        urlPath += `/${this.selectedFacets.find(f => f.name == 'stripreeks').values[0]}`
        categoriesWithFacets.filter(f => f.name != 'stripreeks').forEach((c) => {
          let facets = c.values.sort((x) => x.name);
          let facetString = facets.join(",");
          urlPath = `${urlPath}/${c.name}:${facetString}`;
        });
      }else {
        categoriesWithFacets.forEach((c) => {
          let facets = c.values.sort((x) => x.name);
          let facetString = facets.join(",");
          urlPath = `${urlPath}/${c.name}:${facetString}`;
        });
      }

      if(this.selectedDateInterval) {
        urlPath += `/verschenen:${this.selectedDateInterval}`;
      }

      if (this.page) {
        urlPath += `?pagina=${this.page}`;
      } else {
        urlPath += `?pagina=1`;
      }

      if (this.selectedSort) urlPath += `&sorteren=${this.selectedSort}`; 
      return urlPath;
    },
    updateUrl: function () {
      let urlPath = this.getUrl();
      history.pushState(null, null, urlPath);
    },
    parseUrl() {
      let queryStringParams = window.location.search;
      let path = window.location.pathname.replace(/^\/|\/$/g, ""); // remove leading & trailing slashes
      let pathElements = path.split("/");
      if (pathElements.length == 0) {
        // todo erro handling
      }

      let facetCategories = [];
      let dateInterval = null;

      for (let i = 1; i < pathElements.length; i++) {
        let facetCategory = {};
        if(i == 1 && pathElements[i].indexOf(':') == -1) {
          facetCategory.name = 'stripreeks';
          facetCategory.values = [pathElements[i]];
          this.isSeriesDetail = true;
          facetCategories.push(facetCategory);
        } else {
          let nameItemsSplit = pathElements[i].split(':');
          if (nameItemsSplit.length != 2) {
            // TODO error handling
          }
          var name = nameItemsSplit[0];
          if(name.toLowerCase() == 'verschenen') {
            dateInterval = nameItemsSplit[1].split(",")[0];
          } else {
            let itemsSplit = nameItemsSplit[1].split(",");
            facetCategory.name = name;
            facetCategory.values = itemsSplit;
            facetCategories.push(facetCategory);
          }
        }
      }

      let urlParams = new URLSearchParams(queryStringParams);
      let page = urlParams.get("pagina");
      let sort = urlParams.get("sorteren");

      let parsedUrl = {
        category: pathElements[0],
        facetCategories: facetCategories,
        dateInterval: dateInterval,
        page: page,
        sort: sort,
      };

      return parsedUrl;
      // TODO, page & order
    },
    buildAjaxUrl(category, facetCategories, dateInterval, page, sort) {
      let url = `/SolrCategoryFacets?category=${category}`;
      facetCategories.forEach((f) => {
        f.values.forEach((v) => {
          url += `&${f.name}=${v}`;
        });
      });

      if (dateInterval) {
        url += "&verschenen=" + dateInterval;
      }

      if (sort) {
        url += "&sort=" + sort;
      }

      if (page) {
        url += "&page=" + page;
      }

      return url;
    },
  },
};
</script>